var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pp-container"},[_c('h1',{staticClass:"title"},[_vm._v("Terms and Conditions")]),_c('a',{staticClass:"wpembed-inline",attrs:{"href":"https://app.websitepolicies.com/policies/view/dxwmrru8"}},[_vm._v("Terms and conditions")])])
}]

export { render, staticRenderFns }